"use client";

import { useTranslation } from "react-i18next";

import { DialogContent, DialogHeader, DialogTitle } from "../dialog.tsx";

import { SlotEditContent } from "./slot-edit-content";

export default function SlotEditModal() {
  const { t } = useTranslation("forms");

  // @ts-ignore
  return (
    <DialogContent
      aria-describedby={undefined}
      className="bg-background absolute! left-0 flex h-dvh max-w-full translate-x-0! flex-col gap-0 rounded-e-none! border-none p-0 md:left-[35%] md:max-h-dvh md:max-w-[65%] xl:left-[60%] xl:max-w-[40vw]"
    >
      <DialogHeader className={"w-full ps-4 pt-5 sm:ps-8"}>
        <DialogTitle className={"text-start"}>
          <p className={"text-xl font-semibold"}>{t("slotEdit.slotEdition")}</p>
        </DialogTitle>
      </DialogHeader>
      <SlotEditContent />
    </DialogContent>
  );
}
